const formatPhoneNumberWithDash = (input: string): string => {
  if (!input) return;
  if (input.length === 10) {
    return input.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  }
};

export default formatPhoneNumberWithDash;
